<template>
  <div class="drawer__header" data-js="get-height">
    <v-layout align-center justify-start>
      <v-btn
        v-if="history.length > 1"
        icon
        @click="goBack"
      >
        <v-icon color="gray-6">keyboard_arrow_left</v-icon>
      </v-btn>

      <v-flex class="drawer__title">{{ $t(`${namespace}.title`) }}</v-flex>
    </v-layout>

    <v-btn icon @click="close">
      <v-icon color="gray-6">close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { hasRole } from 'utils/functions'

export default {
  name: 'Header',
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports.header'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    goBack () {
      this.$emit('goBack')
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
